import { css } from "@emotion/react";
import colors from "assets/css/colors";
import primaryButtonCss from "assets/css/buttons/primaryButton.css";
import { modalContainerCss } from "assets/css/modal.css";

export default {
  actionSelectWrapper: css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  `,
  sendBtn: [
    primaryButtonCss,
    css`
      padding: 8px;
      border-radius: 2px;

      &:active,
      &:hover {
        background-color: ${colors.darkBlue};
        box-shadow: unset;
      }
    `,
  ],
  container: [
    modalContainerCss,
    css`
      max-width: initial;
    `,
  ],
  outerWrapper: css`
    max-width: 1110px;
  `,
};
